"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var page_layout_html_1 = __importDefault(require("./page-layout.html"));
require("./page-layout.less");
(function (module) {
    'use strict';
    module.directive('prPageLayout', [
        function () {
            return {
                templateUrl: page_layout_html_1.default,
                scope: {
                    /*
                     * An object that will be updated with the form values and defaults
                     */
                    pageLayout: '=',
                    unit: '='
                },
                bindToController: true,
                controller: 'prPageLayoutController',
                controllerAs: '$ctrl'
            };
        }
    ]);
})(angular.module('qualtrics.pr'));
